import tracerVuePlugin from '@mc/tracer-vue-plugin'
// import { domain } from '@/defines/environment/config'
// 获取页面相关信息
export const getTracerCurrentPageInfo = pageInfo => {
  const currentPage = pageInfo || tracerVuePlugin.tracer.getCurrentPage()
  let host = 'https://online.yunshanmeicai.com'
  if (location.host.includes('linmontop.com.cn')) {
    host = 'https://online.linmontop.com.cn'
  }
  const urlHasPrefix = currentPage.url.indexOf(host)
  const currentPageUrl =
    urlHasPrefix > -1 ? currentPage.url : host + currentPage.url
  const tracerCurrentPageInfo = {
    pageId: currentPage.page_id,
    pageUrl: currentPageUrl
  }
  return tracerCurrentPageInfo
}

/**
 * @description 获取路由跳转携带的额外的关于tracer的参数(session_id, refer_id)
 * @export
 * @returns
 */
export function getTracerExtraParams() {
  // eslint-disable-next-line camelcase
  const { session_id, refer_id } = tracerVuePlugin.tracer.getCurrentPage()
  return {
    tickSessionId: session_id,
    tickReferId: refer_id
  }
}

/**
 * 处理spm，params，markedKey
 * @param  {...any} args spm, params, ...
 * @param  {object} baseData
 * @param  {object} baseData._baseParam 入参是否是基础参数（用于区别 params）
 * @returns {object} obj
 * @returns {string} obj.spm
 * @returns {object} obj.params
 * @returns {string} obj.markedKey
 * @returns {object} obj.baseData 技术埋点参数
 */
const formatTracerArgs = (...args) => {
  let spm = args[0]
  const params = {}
  const baseData = {}
  const markedKey =
    args[args.length - 1] instanceof Array ? args[args.length - 1] : []
  const context =
    args[1] && (typeof args[1] === 'string' || typeof args[1] === 'number')
      ? args[1]
      : '0'
  args?.forEach?.((item, index) => {
    if (index !== 0 && typeof item === 'object' && !(item instanceof Array)) {
      if (item._baseParam) {
        Object.assign(baseData, item._baseParam)
      } else {
        Object.assign(params, item)
      }
    }
  })

  const spmArr = String(spm).split('.')
  if (spmArr[0] !== 'm' && spmArr[0] !== 'n') {
    // spm = spmArr.reduce((spmObj, key) => {
    //   if (!spmObj) return null
    //   return spmObj[key]
    // })
    spm = spm && spm.replace(/(\w+)(\.)?(\w+)?$/, `$1.${context}`)
  }
  return {
    spm,
    params,
    markedKey,
    baseData
  }
}

const handleSpm = (spm = '0.0', pageId) => {
  const spmResult = ['n', +pageId ? pageId : pageId || '0', '0', '0']

  // 写错的提示报错并处理
  spm = spm.split('.').filter(item => {
    return item !== ''
  })

  // 长度为1的补全
  if (spm.length === 1) {
    spm.push('0')
  }

  // 这边主要是完全自定义的场景，注意的是返回完整数组
  if (spm.length > 4 || !/\d/.test(spm[0])) {
    return spm
  }

  // 开始自动填充
  spm.reverse().forEach?.((item, index) => {
    spmResult[3 - index] = item
  })

  return spmResult
}

export function getTickReferId(spmKey, referPos, pageId) {
  if (!spmKey) return ''
  const { spm } = formatTracerArgs(spmKey)
  const spmResult = handleSpm(spm, pageId)
  const spmString = spmResult.join('.')
  return `${spmString}.${referPos}` || ''
}
